import { render } from "./archivesDialog.vue?vue&type=template&id=444d5724&scoped=true"
import script from "./archivesDialog.vue?vue&type=script&lang=js"
export * from "./archivesDialog.vue?vue&type=script&lang=js"

import "./archivesDialog.vue?vue&type=style&index=0&id=444d5724&scoped=true&lang=less"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444d5724"]])

export default __exports__